module.exports = "/_next/static/images/ThePayoff-sm-5158d68aaac1ed95497d415c50f5aba1.png";